/**
 * Reproduce videos de fondo (marcados con .lm-lazy-video) recién cuando
 * se acercan al viewport, en vez de usar el atributo autoplay (que hace
 * que el navegador precargue el archivo completo desde el primer render).
 */
(function () {
  var videos = document.querySelectorAll('video.lm-lazy-video');
  if (!videos.length) return;

  function playVideo(video) {
    video.play().catch(function () {
      /* autoplay puede fallar en algunos navegadores; el poster sigue visible */
    });
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(playVideo);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          playVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '400px 0px' }
  );

  videos.forEach(function (video) {
    observer.observe(video);
  });
})();
